module.exports = __webpack_public_path__ + "img/empty-group-profile.a23856da.svg";